<template>
  <div>
    <div id="register-page" class="form-signin">
      <form
        action=""
        method="POST"
        enctype="multipart/form-data"
        @submit.prevent="register"
      >
        <h3 id="title-register">REGISTER TO JUSTEAT!</h3>
        <div class="form-floating mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="Password"
            v-model="fullName"
          />
          <label>Fullname</label>
        </div>
        <div class="form-floating mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="Password"
            v-model="userName"
          />
          <label for="floatingPassword">Username</label>
        </div>
        <div class="form-floating mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="name@example.com"
            v-model="email"
          />
          <label for="floatingInput">Email address</label>
        </div>
        <div class="form-floating mb-3">
          <input
            type="password"
            class="form-control"
            placeholder="Password"
            v-model="password"
          />
          <label for="floatingPassword">Password</label>
        </div>
        <div class="btn">
          <Button type="submit" class="btn btn-primary" buttonText="Sign Up"></Button>
        </div>
      </form>
      <p style="color: white">Already have an account? <a href="" @click.prevent="toLogin">Login</a></p>
    </div>
  </div>
</template>

<script>
import Button from "../components/button.vue"
export default {
  name: "Register",
  components:{
    Button
  },
  data() {
    return {
      fullName: "",
      email: "",
      userName: "",
      password: "",
    };
  },
  methods: {
    register() {
      const userData = {
        fullName: this.fullName,
        email: this.email,
        userName: this.userName,
        password: this.password,
      };
      this.$emit("registerData", userData);
    },
    toLogin(){
      this.$emit('toLogin')
    }
  },
};
</script>

<style>
</style>